import React from 'react';

import { Helpers } from '../core/src/helpers';
import ConditionalWrapper from '../shared/components/conditional-wrapper';
import Link from '../shared/components/hyperlink';

import './top-banner.less';
import { HighlightBanner } from '@hpstellar/core';
import { withError } from '../shared/components/error-boundary';

import { getHighlightBannerContent, getCountdownProps } from '../utility/setHtml';

export default withError(
    ({
        html,
        css,
        countDownEnabled,
        endtime,
        className,
        countDownFormat = 'dd:hh:mm:ss',
        countDownMessage,
        bannerUrl,
        children,
        dataAttributes = {},
    }) => {
        countDownFormat = countDownFormat || 'dd:hh:mm:ss';

        const current = new Date();
        const end = new Date(endtime);
        const shouldShowCountdown = current.getTime() <= end.getTime();

        return (
            <ConditionalWrapper
                condition={!!bannerUrl}
                wrapper={children => (
                    <Link aria-label="Banner" to={bannerUrl}>
                        {children}
                    </Link>
                )}
            >
                <div id="topBanner" className={`top-banner${className ? ' ' + className : ''}`} {...dataAttributes}>
                    <div dangerouslySetInnerHTML={Helpers.createMarkup(html)} />
                    {children}
                </div>
                <style dangerouslySetInnerHTML={Helpers.createMarkup(css)}></style>
                {countDownEnabled && shouldShowCountdown ? (
                    <HighlightBanner
                        {...getHighlightBannerContent({ title: countDownMessage })}
                        countdownTimerProps={{
                            endTime: end,
                            ...getCountdownProps(countDownFormat)
                        }}
                        className="banner-countdown"
                    />
                ) : null}
            </ConditionalWrapper>
        );
    }
);
